<template>
<div class="container" v-if="this.factsheet.info.config.selected_options.includes('is_svi')">
  <div class="row">
      <div class="col 2-col">
        <h2 id="sustainability">5. Sustainability Analysis</h2>
        <p>Due to limited relevance to the vanilla sector, the contents of this section have been omitted for the SVI commune-level reports.</p>
      </div>
    </div>
  </div>
  <div v-else class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="sustainability">5. Sustainability Analysis</h2>
        
        <div>
        <p>Use carbon balance data and climate change projections to understand:</p>
        <ul>
            <li>your landscape’s role in carbon emissions: is it emitting carbon or removing it from the atmosphere?</li>
            <li>the impact of climate change on your landscape</li>
        </ul>
      </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>5.1 Forest Carbon Balance</h3>
        <p>
            This section calculates whether forests in the area released more carbon than it absorbed between 2001 to 2021. The two maps show: </p>
        <ul>
          <li>carbon sources: where CO₂ that was stored in the forest was released into the atmosphere through forest degradation, for example burning.</li>
          <li>carbon sinks: where mature or regenerating forests remove CO₂ from the atmosphere and fix it within woody parts of the trees.</li>
        </ul>
        <p>
          The model works best where there is a tree canopy density of more than 30%.
        </p>

        <div class="factsheet-status-notice" v-if="!carbonBudget">
            <p><strong>Data for the forest carbon balance still needs to be generated for this report.</strong></p>
            </p>
        </div>

      </div>
    </div>

    <div class="row text-center align-items-center" v-if="carbonBudget">
      <div class="col-4">
        <h3>2000</h3>
        <div style="background-color:#f5f5f5;padding:20px 10px 10px 10px;">
            <div  style="color:#666;font-size:1.4em;">

              <b>{{ carbonBudget.biomass_2000_abs_tot | tco2e(yearly) }}</b>{{ carbonBudget.biomass_2000_abs_tot | tco2e_units(yearly)}}
                <br/>
                <span style="font-size:0.5em;font-weight:bold;">stored in forested areas</span>
            </div>
          <!--<div style="color:#888;padding-top:5px;font-size:0.7em;font-weight:bold;">(XXXtCO₂2/ha)</div>-->
          <!--
              <span style="float:right;font-size:0.6em;font-weight:bold;color:#3f9b0b;padding-top:5px;">Other forest</span>
              <span style="float:left;font-size:0.6em;font-weight:bold;color:#087804;padding-top:5px;">37% in primary forest</span>

              <br clear="left" />
              <div class="progress" style="height:6px;background-color:#ddd;margin:3px 0px;">
                <div class="progress-bar" role="progressbar" style="background-color:#087804;width:75%;border-right:2px solid #f5f5f5;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                <div class="progress-bar" role="progressbar" style="background-color:#3f9b0b;width:25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
    
              </div>
              -->
          </div>
      </div>
      <div class="col-4">
        
        <h3>Change</h3>

          <div style="background-color:#f5f5f5;padding:20px;height:114px;">

            <div class="row align-items-center">

              <div class="col-12 text-center">


                <div v-if="carbonBudget.flux_net_tot > 0" style="color:#572578;font-size:1.4em;">
                  <b>{{ carbonBudget.flux_net_tot | tco2e(yearly) }}</b>{{ carbonBudget.flux_net_tot | tco2e_units(yearly)}}<br/>
                  <span style="font-size:0.5em;font-weight:bold;">emitted from forested areas</span>
                </div>
                <div v-if="carbonBudget.flux_net_tot < 0" style="color:#06942c;font-size:1.4em;">
                  <b>{{ carbonBudget.flux_net_tot | tco2e(yearly) }}</b>{{ carbonBudget.flux_net_tot | tco2e_units(yearly)}}<br/>
                  <span style="font-size:0.5em;font-weight:bold;">removed from the atmosphere</span>
                </div>

                <div style="color:#888;padding-top:5px;font-size:0.7em;font-weight:bold;">({{ carbonBudget.flux_net_ha_avg | tco2e(yearly) }}{{ carbonBudget.flux_net_ha_avg | tco2e_units(yearly) }}/ha) 
                  
                </div>
                
              </div>
            </div>

          </div>

      </div>
      <div class="col-4">
        <h3>2021</h3>
        <div style="background-color:#f5f5f5;padding:20px 10px 10px 10px;">
            <div  style="color:#666;font-size:1.4em;">
                <b>{{ (carbonBudget.biomass_2000_abs_tot - carbonBudget.flux_net_tot) | tco2e(yearly) }}</b>{{ (carbonBudget.biomass_2000_abs_tot - carbonBudget.flux_net_tot)| tco2e_units(yearly)}}
                <br/>
                <span style="font-size:0.5em;font-weight:bold;">stored in forested areas</span>
            </div>
          <!--<div style="color:#888;padding-top:5px;font-size:0.7em;font-weight:bold;">(XXXtCO₂2/ha)</div>-->
          <!--
              <span style="float:right;font-size:0.6em;font-weight:bold;color:#3f9b0b;padding-top:5px;">Other forest</span>
              <span style="float:left;font-size:0.6em;font-weight:bold;color:#087804;padding-top:5px;">Primary forest</span>
              <br clear="left" />
              <div class="progress" style="height:6px;background-color:#ddd;margin:3px 0px;">
                <div class="progress-bar" role="progressbar" style="background-color:#087804;width:65%;border-right:2px solid #f5f5f5;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                <div class="progress-bar" role="progressbar" style="background-color:#b0dd16;width:10%;border-right:2px solid #f5f5f5;"" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                <div class="progress-bar" role="progressbar" style="background-color:#3f9b0b;width:25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                
                
              </div>-->
          </div>
      </div>
    </div>
    <div class="row align-items-center" style="margin:15px 0px 10px 0px;"  v-if="carbonBudget">
      <div class="col-4 offset-1 text-center" style="font-size:0.9em;color:#666;font-weight:bold;">
        Forest Carbon Emissions <a class="explainer-link" href="#" @click.prevent="explainerStart('ldr_carbon_sources')" style="font-size:0.95em;"><i class="bi bi-question-circle"></i></a>
      </div>
      <div class="col-1 text-left"><i class="bi bi-arrow-up-right" style="font-size:1.3em;color:#666;"></i></div>
      <div class="col-1 text-right"><i class="bi bi-arrow-up-left" style="font-size:1.3em;color:#666;"></i></div>
      <div class="col-4 text-center" style="font-size:0.9em;color:#666;font-weight:bold;">
        Forest Carbon Sinks <a class="explainer-link" href="#" @click.prevent="explainerStart('ldr_carbon_sinks')" style="font-size:0.95em;"><i class="bi bi-question-circle"></i></a>
      </div>
    </div>

    <div class="row" v-if="carbonBudget">
      <div class="col">

        <div style="background-color:#f5f5f5;padding:8px;marign-bottom:-10px;">
          <div class="row" style="padding-bottom:10px;">
            <div class="col">
              <div style="font-size:0.65em;font-weight:bold;color:#572578;text-align:left;">{{ (carbonBudget.ha_forested_positive/carbonBudget.ha_forested_total) | percent }} of the forested area is a carbon source</div>
              <div class="progress" style="height:6px;background-color:#ddd;margin:3px 0px;">
                <div v-for="bar in leftBar((carbonBudget.ha_forested_positive/carbonBudget.ha_forested_total)*100)" class="progress-bar" role="progressbar" v-bind:style="bar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-4 text-center">
              <img style="width:100%;" src="../../../assets/factsheets/ldr/carbon_sources.png">
            </div>
            <div class="col-8 text-center">
              <div style="color:#572578;font-size:1.4em;">+<b>{{ carbonBudget.flux_pos_abs_tot | tco2e(yearly) }}</b>{{ carbonBudget.flux_pos_abs_tot | tco2e_units(yearly)}}</div>
              <div style="color:#888;padding-top:5px;font-size:0.7em;font-weight:bold;">({{ carbonBudget.flux_pos_ha_avg | tco2e(yearly) }}{{ carbonBudget.flux_pos_ha_avg | tco2e_units(yearly) }}/ha)</div>
            
            </div>
          </div>
        </div>

        <RasterMap 
          backgrounds="light," 
          title="Forest Carbon Emissions (Sources)" 
          attribution="Map: Geofolio. Data: Carbon Fluxes by Harris et al. [6]. Backgrounds: Mapbox/Openstreetmap Contributors [2]." 
          hideOptions="true" 
          hideLayers="true" 
          hideTitle="true" 
          v-bind:layout="{legendWidth:12, legendCols:1, descriptionWidth:12, order:['legend','description'] }"
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          v-bind:layers="[{'title': 'Emissions', 'source': '/ldr_carbon_balance/flux_pos_ha.tif'}]">

          <p>This map shows carbon emissions into the atmosphere (sources) in tons of CO₂ equivalent per hectare over the whole period 2000-2021. It is common to convert all types of greenhouse gases 
          (CO₂, methane, nitrous oxide) to the equivalent in CO₂ so that they may easily be compared against one another.</p>
        </RasterMap>

      </div>
      <div class="col">


        <div style="background-color:#f5f5f5;padding:8px;">

          <div class="row" style="padding-bottom:10px;">
            <div class="col">
              <div class="text-right" style="font-size:0.65em;font-weight:bold;color:#06942c;text-align:left;">{{ (carbonBudget.ha_forested_negative/carbonBudget.ha_forested_total) | percent }} of the forested area is a carbon sink</div>
              <div class="progress" style="height:6px;background-color:#ddd;margin:3px 0px;">
                <div v-for="bar in rightBar((carbonBudget.ha_forested_positive/carbonBudget.ha_forested_total)*100)" class="progress-bar" role="progressbar" v-bind:style="bar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-8 text-center">
              <div style="color:#06942c;font-size:1.4em;">&ndash;<b>{{ carbonBudget.flux_neg_abs_tot | tco2e(yearly)}}</b>{{ carbonBudget.flux_pos_abs_tot | tco2e_units(yearly)}}</div>
              <div style="color:#888;padding-top:5px;font-size:0.7em;font-weight:bold;">({{ carbonBudget.flux_neg_ha_avg | tco2e(yearly)}}{{ carbonBudget.flux_neg_ha_avg | tco2e_units(yearly)}}/ha)</div>
            </div>
            <div class="col-4">
              <img  style="width:100%;" src="../../../assets/factsheets/ldr/carbon_sinks.png" />
            </div>
          </div>
        </div>

        <RasterMap 
          backgrounds="light," 
          title="Carbon Removals (Sinks)" 
          attribution="Map: Geofolio. Data: Carbon Fluxes by Harris et al. [6]. Backgrounds: Mapbox/Openstreetmap Contributors [2]." 
          hideOptions="true" 
          hideLayers="true" 
          hideTitle="true" 
          v-bind:layout="{legendWidth:12, legendCols:1, descriptionWidth:12, order:['legend','description'] }"
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          v-bind:layers="[{'title': 'Capture', 'source': '/ldr_carbon_balance/flux_neg_inv_ha.tif'}]">

          <p>This map shows carbon removals from the atmosphere (sinks) in tons of CO₂ equivalent per hectare over the whole period 2000-2021. It is common to convert all types of greenhouse gases 
          (CO₂, methane, nitrous oxide) to the equivalent in CO₂ so that they may easily be compared against one another.</p>
        </RasterMap>


      </div>

    </div>




    <div class="row">
      <div class="col">
        <h3>5.2 Climate Change Projections</h3>
        <p>Use this data to anticipate how changes to weather patterns may impact elements in your landscape, for example crop productivity.</p>

        <p>This data shows climate change projections for 2020, 2050 and 2080, compared to a baseline from the period between 1960 to 2000. The data comes from the Partnership for Resilience and Preparedness (PREP). Climate projections are predictions of what may happen, based on data available from the past and models to recreate climate patterns. </p>

          <p>It projects data for two scenarios:</p>
          <ul>
          <li>high emissions scenario: where greenhouse gas emissions are not limited</li>
          <li>low emissions scenario: where greenhouse gas emissions decline towards the end of the century thanks to efforts to limit them</li>
          </ul>


        <div class="factsheet-status-notice" v-if="!climateProjections">
            <p><strong>Data for future climate projections still needs to be generated for this report.</strong></p>
            </p>
        </div>
      </div>
    </div>
    <div class="row" v-if="climateProjections">
 
      <div class="col col-10 offset-1">
        <table class="table table-sm text-center" style="font-size:0.8em;background-color:#f5f5f5;">
          <!--<caption>Simplified Climate Change Projections</caption>-->
          <tr>  
            <th colspan="5" class="text-left" style="font-weight:normal;border:none;padding:10px 8px;background-color:#eee;">


              <form id="rcp">

                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="rcp45" v-model="rcp">
                  <label class="form-check-label" for="inlineRadio1">Low emissions (RCP 4.5)</label>
                </div>
                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="rcp85" v-model="rcp">
                  <label class="form-check-label" for="inlineRadio2">High emissions (RCP 8.5)</label>
                </div>

                
                  <a class="explainer-link" style="float:right" href="#" @click.prevent="explainerStart('clim_proj_scenarios')"><i class="bi bi-question-circle"></i></a>
                
                </form>


            </th>
          </tr>

          <tr><th class="text-left align-middle" colspan="2" style="padding:10px 8px;">
            Simplified climate change projections for year:
          </th>
            <th class="align-middle" style="width:130px;">2020</th>
            <th class="align-middle" style="width:130px;">2050</th>
            <th class="align-middle" style="width:130px;">2080</th>
          </tr>

          <tr style="height:65px;">
            <td class="align-middle text-center" style="width:65px;background-color:#f5f5f5;"><i class="bi bi-thermometer-sun" style="font-size:1.5em;"></i></td>
            <td class="text-left align-middle" style="width:50%;">
              Number of extreme heat days <a class="explainer-link" href="#" @click.prevent="explainerStart('clim_proj_indicators')" ><i class="bi bi-question-circle"></i></a>
              <!--<p style="font-size:0.75em;line-height:1.2em;margin:0;">Number of extreme heat days compared to baseline of 1960-2000.</p>-->
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_extreme_heat_days_change_2020.p50 | fixed0 | suffix('days') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_extreme_heat_days_change_2020.p50 | fixed0 | suffix('days') }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_extreme_heat_days_change_2050.p50 | fixed0 | suffix('days') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_extreme_heat_days_change_2050.p50 | fixed0 | suffix('days') }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_extreme_heat_days_change_2080.p50 | fixed0 | suffix('days')  }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_extreme_heat_days_change_2080.p50 | fixed0 | suffix('days')  }}</span>
            </td>
          </tr>

          <tr style="height:65px;">
            <td class="align-middle text-center" style="width:0%;background-color:#f5f5f5;"><i class="bi bi-droplet" style="font-size:1.35em;margin-left:-4px;"></i></td>
            <td class="text-left align-middle" style="width:50%;">
              Number of dry spells <a class="explainer-link" href="#" @click.prevent="explainerStart('clim_proj_indicators')" ><i class="bi bi-question-circle"></i></a>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_dryspells_change_2020.p50 | frac2perc | suffix('') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_dryspells_change_2020.p50 | frac2perc | suffix('') }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_dryspells_change_2050.p50 | frac2perc | suffix('')  }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_dryspells_change_2050.p50 | frac2perc | suffix('')  }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_dryspells_change_2080.p50 | frac2perc | suffix('')  }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_dryspells_change_2080.p50 | frac2perc | suffix('')  }}</span>
            </td>
          </tr>


          <tr style="height:65px;">
            <td class="align-middle text-center" style="width:0%;background-color:#f5f5f5;"><i class="bi bi-cloud-rain" style="font-size:1.35em;margin-left:-4px;"></i></td>
            <td class="text-left align-middle" style="width:50%;">
              Change in annual precipitation <a class="explainer-link" href="#" @click.prevent="explainerStart('clim_proj_indicators')" ><i class="bi bi-question-circle"></i></a>
              <!-- <p style="font-size:0.75em;line-height:1.2em;margin:0;">Annual cumulative precipitation compared to baseline of 1960-2000.</p>-->
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2020.p50 | signed }}{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2020.p50 | fixed1  | suffix('mm')}}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2020.p50 | signed }}{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2020.p50 | fixed1  | suffix('mm')}}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2050.p50 | signed  }}{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2050.p50 | fixed1  | suffix('mm') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2050.p50 | signed  }}{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2050.p50 | fixed1  | suffix('mm') }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2080.p50 | signed  }}{{ climateProjections.rcp45_annual_cumulative_precipitation_change_2080.p50 | fixed1  | suffix('mm') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2080.p50 | signed  }}{{ climateProjections.rcp85_annual_cumulative_precipitation_change_2080.p50 | fixed1  | suffix('mm') }}</span>
            </td>
          </tr>

          <tr style="height:65px;">
            <td class="align-middle text-center" style="width:0%;background-color:#f5f5f5;"><i class="bi bi-thermometer-high" style="font-size:1.35em;margin-left:-4px;"></i></td>
            <td class="text-left align-middle" style="width:50%;">
              Change in annual temperature <a class="explainer-link" href="#" @click.prevent="explainerStart('clim_proj_indicators')" ><i class="bi bi-question-circle"></i></a>
              <!--<p style="font-size:0.75em;line-height:1.2em;margin:0;">Annual average temperature compared to baseline of 1960-2000.</p>-->
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_temperature_change_2020.avg | signed }}{{ climateProjections.rcp45_temperature_change_2020.avg | fixed1 | suffix('°C')}}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_temperature_change_2020.avg | signed }}{{ climateProjections.rcp85_temperature_change_2020.avg | fixed1 | suffix('°C')}}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_temperature_change_2050.avg | signed }}{{ climateProjections.rcp45_temperature_change_2050.avg | fixed1 | suffix('°C') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp85_temperature_change_2050.avg | signed  }}{{ climateProjections.rcp85_temperature_change_2050.avg | fixed1 | suffix('°C') }}</span>
            </td>
            <td class="align-middle">
              <span v-show="rcp == 'rcp45'">{{ climateProjections.rcp45_temperature_change_2080.avg | signed  }}{{ climateProjections.rcp45_temperature_change_2080.avg | fixed1 | suffix('°C') }}</span>
              <span v-show="rcp == 'rcp85'">{{ climateProjections.rcp45_temperature_change_2080.avg | signed  }}{{ climateProjections.rcp45_temperature_change_2080.avg | fixed1 | suffix('°C') }}</span>
            </td>
          </tr>

          <tr>
            <td colspan="6" style="text-align:left;font-size:0.8em;color:#888;padding:4px 8px;">
              Source: Partnership for Resilience and Preparedness (PREP) 
            </td>
          </tr>

        </table>

      </div>
    </div>


    <div class="row">
      <div class="col">
        <p>
          Climate change can also affect the suitability of crops in this area. The table below shows crops which are 
          suitable for this area, and how the suitability may improve or get worse in the future. The suitability values 
          range from 0 to 100.
        </p>

        <div class="factsheet-status-notice" v-if="!agricultureSuitability">
            <p><strong>Data for future crop suitabilities still needs to be generated for this report.</strong></p>
            </p>
        </div>
      </div>
    </div>

    <div class="row" v-if="agricultureSuitability">

      <div class="col col-10 offset-1">
        <table class="table table-sm text-center" style="font-size:0.8em;background-color:#f5f5f5;">
          <!--<caption>Simplified Climate Change Projections</caption>-->
          <tr>  
            <th colspan="4" class="text-left" style="font-weight:normal;border:none;padding:10px 8px;background-color:#eee;">


              <form id="rcp">

                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" disabled type="radio" name="inlineRadioOptions" id="crop-rcp45" value="rcp45" v-model="cropRcp">
                  <label class="form-check-label" for="crop-rcp45">Low emissions (not available)</label>
                </div>
                <div class="form-check form-check-inline" style="">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="crop-rcp85" value="rcp85" v-model="cropRcp">
                  <label class="form-check-label" for="crop-rcp85">High emissions (RCP 8.5)</label>
                </div>

                
                  <a class="explainer-link" style="float:right" href="#" @click.prevent="explainerStart('clim_proj_scenarios_crops')"><i class="bi bi-question-circle"></i></a>
                
                </form>


            </th>
          </tr>

          <tr><th class="text-left align-middle" style="padding:10px 8px;">
            Most suitable crops:
          </th>
            <th class="align-middle" style="width:130px;">Historical</th>
            <th class="align-middle" style="width:130px;">2040-2070</th>
            <th class="align-middle" style="width:130px;">2070-2100</th>
          </tr>

          <tr style="" v-for="crop in agricultureSuitability.crop_suitability.slice(0,8)">
            <td class="text-left align-middle" style="width:50%;padding:10px 8px;">
              {{crop.title}}
            </td>
            <td class="align-middle">
              <span>{{ crop['1980-2009_hist'] | suitability  }}</span>
            </td>
            <td class="align-middle">
              <span>{{ crop['2040-2069_rcp8p5'] | suitability  }}</span>
              <span v-html="makeDifference(crop['1980-2009_hist'], crop['2040-2069_rcp8p5'])"></span>
            </td>
            <td class="align-middle">
              <span>{{ crop['2070-2099_rcp8p5'] | suitability  }}</span>
              <span v-html="makeDifference(crop['1980-2009_hist'], crop['2070-2099_rcp8p5'])"></span>
            </td>
          </tr>

          <tr>
            <td colspan="4" style="text-align:left;font-size:0.8em;color:#888;padding:4px 8px;">
              Source: Zabel (2022)
            </td>
          </tr>
          

        </table>

      
        </div>

    </div>
    <div class="row">
      <div class="col">

            <div class="factsheet-caution-notice">
          
          
            <p><strong><i class="bi bi-exclamation-circle" style="font-size:1.5em;float:left;margin-right:8px;"></i> Use with caution! The insights derived from climate projections are very uncertain.</strong></p>
            <p>
            The insights derived from climate change projections in this section are very uncertain and have not been
            checked or verified by an expert. Not all crops are available in the suitability analysis. Contact us if you 
            are interested in other climate projections or in a suitability analysis for other crops.
            </p>
          
          
        </div>
      </div>
    </div>



    <div class="row">
      <div class="col">
        <h3>5.3 Land Degradation Neutrality</h3>
        <p>
          The land degradation neutrality method can be used to analyse positive and negative changes in land use between two different points in time. 
          The analysis shown here shows the changes between 2000 and 2020. All the changes that have occurred between the two years are 
          classified into one of three types:
        </p>
        <ul>
          <li>Positive changes which are improvements (for example a change from shrubland to forest)</li>
          <li>Negative changes which are degradations (for example a change from forest to cropland)</li>
          <li>No change or a neutral change</li>
        </ul>
        <p>
          The bar chart shown below uses land cover data from the Climate Change Initiative (CCI) of the European Space 
          Agency. The map with the overview of changes has been added to the Atlas at the end of this report.
        </p>
        <div class="factsheet-status-notice" v-if="!ldr">
            <p><strong>Data for the land degradation neutrality calculation still needs to be generated for this report.</strong></p>
        </div>
        
      </div>
    </div>
    <LandDegradationNeutrality v-if="ldr" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:ldr="ldr" v-bind:loaded="loaded" />


  </div>
</template>

<script>
    /* eslint-disable */

    import _ from 'lodash';
    
    import RasterMap from '@/components/factsheet/RasterMap.vue'
    import LandDegradationNeutrality from '@/components/factsheet/LandDegradationNeutrality.vue'

    export default {
        name: 'SustainabilityIndicators',
        components: { RasterMap, LandDegradationNeutrality },
        props: ['location', 'factsheet', 'loaded'],
        data() {
          return {
              yearly: false,
              rcp: 'rcp85',
              cropRcp: 'rcp85'
          }
        },
        created() {
          if(this.factsheet["info"]["location"]["country"] == 'ci') {
            //this.layers.push({'title': 'Land Cover (IMAGES, 2019)', 'source': '/images_forest_alerts/rsac_land_use.tif'});
            //this.layers.push({'title': 'Cocoa Probability (ETH, 2020)', 'source': '/eth_cocoa_maps/cocoa_probability.tif'});
          }
        },
        computed: {
          carbonBudget() {
            if(this.loaded && this.factsheet.data["ldr_carbon_balance"]) {
              var balance = this.factsheet.data["ldr_carbon_balance"].balances[0]
              balance["flux_net_tot"] = balance["flux_pos_abs_tot"] + balance["flux_neg_abs_tot"]
              balance["flux_net_ha_avg"] = balance["flux_pos_ha_avg"] + balance["flux_neg_ha_avg"]
              return balance              
            } else {
              return null;
            }
          },
          climateProjections() {
            if(this.loaded && this.factsheet.data["wri_resourcewatch_clim_proj"]) {
              return this.factsheet.data["wri_resourcewatch_clim_proj"]
            } else {
              return null
            }
          },
          agricultureSuitability() {
            if(this.loaded && this.factsheet.data["future_crop_suitability"]) {
              return this.factsheet.data["future_crop_suitability"]
            } else {
              return null
            }
          },
          ldr() {
            if(this.loaded && this.factsheet.data["land_degradation_neutrality"]) {
              return this.factsheet.data["land_degradation_neutrality"]
            } else {
              return null;
            }
          }
        },
        mounted() {

        },
        methods: {
          leftBar(value) {
            return ["width:"+value+"%;background-color:#572578;"]
          },
          rightBar(value) {
            return ["width:"+value+"%;background-color:#dddddd;", "width:"+(100-value)+"%;background-color:#06942c;"]
          },
          makeDifference(baseline, value) {
            var diff = value - baseline;
            var diffFmt = diff.toFixed(1)

            if((diff < 0.1) && (diff > -0.1))  {
              return "";
            }
            else if(diff > 0) {
              return " <span style='color:#15b01a;'>+"+diff.toFixed(1)+"</span>"
            } else {
              return " <span style='color:#e50000;'>&ndash;"+Math.abs(diff).toFixed(1)+"</span>"
            }
            
          }
        },
        filters: {
          percent: function(value) {
            return (value*100).toFixed(0)+'%'
          },
          tco2e: function (value, yearly) {
            if(yearly) {
              value = value / 21;
            }
            if(Math.abs(value) > 1000000) {
              return (Math.abs(value)/1000000).toFixed(1)
            } else {
              return parseInt(Math.abs(value))
            }
          },
          tco2e_units: function(value, yearly) {
            var year = yearly ? '/yr' : ''
            if(Math.abs(value) > 1000000) {
              return "Mt CO₂e"+year
            } else {
              return "t CO₂e"+year
            }
          },
          fixed0: function(value) {
            return value ? value.toFixed(0) : ''
          },
          fixed1: function(value) {
            return value ? value.toFixed(1) : ''
          },
          fixed2: function(value) {
            return value ? value.toFixed(2) : ''
          },
          frac2perc: function(value) {
            if(value == null) {
              return ''
            }
            var perc = 100 * (value - 1.0)
            if(perc.toFixed(0) == '0' || perc.toFixed(0) == '-0') {
              return '0%'
            }
            if(perc > 0) {
              return '+'+Math.abs(perc.toFixed(0))+'%'
            }
            if(perc < 0) {
              return '–'+Math.abs(perc.toFixed(0))+'%'
            }
          },
          signed: function(value) {
            if(value == null) {
              return ''
            }
            if(value > 0) {
              return '+';
            }
            if (value < 0) {
              return '–';
            }
          },
          suitability: function(value) {
            return value.toFixed(1)
          },
          verify: function(value) {
            return value ? value : 'n/a'
          },
          suffix: function(value, suffix) {
            return ((value != null) && (value != '')) ? value+' '+suffix : 'n/a'
          }

        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
a.explainer-link {
  color:#aaa;
}
a.explainer-link:hover {
  color:#0056b3;
}
</style>